import { Edit } from 'react-admin'

import CourseForm from './CourseForm'
import { attachEpisodeOrder } from './CourseGroupTab'

const transform = data => ({ ...data, groups: attachEpisodeOrder(data.groups) })

const CourseEdit = props => {
  return (
    <Edit undoable={false} transform={transform} {...props}>
      <CourseForm permissions={props.permissions} />
    </Edit>
  )
}

export default CourseEdit
